import {createSlice} from "@reduxjs/toolkit";
import {fetchDrawers} from "./globalComponentsThunks";

export const drawersRepoSlice = createSlice({
    name: 'drawersRepo',
    initialState: {
        drawersRepo: [],
        loading: true,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchDrawers.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchDrawers.fulfilled, (state, action) => {
                state.loading = false;
                state.drawersRepo = action.payload;
            })
            .addCase(fetchDrawers.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    }
});

export default drawersRepoSlice.reducer;